import HomePage from '../components/pages/Home'
import VoloHotelPage from '../components/pages/VoloHotel'
import ExperiencePage from '../components/pages/Experience'
import TourPage from '../components/pages/Tour'
import TourSelectionPage from '../components/pages/TourSelection'
import ExperienceSelectionPage from '../components/pages/ExperienceSelection'
import DetailPage from '../components/pages/Detail'
import TemplatePage from '../components/pages/Template'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/volo-hotel',
    name: 'VoloHotelPage',
    component: VoloHotelPage
  },
  {
    path: '/tour',
    name: 'TourPage',
    component: TourPage
  },
  {
    path: '/experience',
    name: 'ExperiencePage',
    component: ExperiencePage
  },
  {
    path: '/tour-selection',
    name: 'TourSelectionPage',
    component: TourSelectionPage
  },
  {
    path: '/experience-selection',
    name: 'ExperienceSelectionPage',
    component: ExperienceSelectionPage
  },
  {
    path: '/detail',
    name: 'DetailPage',
    component: DetailPage
  },
  {
    path: '/template',
    name: 'TemplatePage',
    component: TemplatePage
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/front/router/routes.js